module.exports = __webpack_public_path__ + "static/media/pda3.b5e1a0c3.png";